export interface CarouselBreakpointsOption {
  slidesPerView?: number;
  spaceBetween?: number;
}
